// extracted by mini-css-extract-plugin
export default {"reg":"styles_reg__VkANn","body":"styles_body__Tp3lT","left":"styles_left__M7Jgw"};